(function () {
  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return new Intl.NumberFormat('de-CH', {
      style: 'currency',
      currency: 'CHF'
    }).format((cents || 0) / 100);
  }

  function initBundle(root) {
    if (!root || root.dataset.bundleInitialized === 'true') return;
    root.dataset.bundleInitialized = 'true';

    const jsonEl = root.querySelector('[data-bundle-products-json]');
    if (!jsonEl) return;

    let data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (error) {
      console.warn('Catzyfied bundle data could not be parsed.', error);
      return;
    }

    const products = data.products || [];
    if (!products.length) return;

    const modelButtons = Array.from(root.querySelectorAll('[data-bundle-model]'));
    const variantButtons = Array.from(root.querySelectorAll('[data-bundle-variant-key]'));
    const masterSelect = root.querySelector('[data-product-select]');
    const priceEl = root.querySelector('[data-bundle-price]');
    const compareEl = root.querySelector('[data-bundle-compare]');
    const savingEl = root.querySelector('[data-bundle-saving]');
    const availability = root.querySelector('[data-bundle-availability]');
    const availabilityText = root.querySelector('[data-bundle-availability-text]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addButtonText = root.querySelector('[data-add-to-cart-text]');
    const fountainName = root.querySelector('[data-bundle-fountain-name]');
    const feederVariant = root.querySelector('[data-bundle-feeder-variant]');

    let selectedProductId = String(data.currentProductId);
    let activeVariantButton = variantButtons.find((button) => button.classList.contains('is-active'));
    let selectedVariantKey = activeVariantButton ? activeVariantButton.dataset.bundleVariantKey : null;


    // Optional deep-link preselection from product pages, e.g.
    // ?brunnen=edelstahl-pro or ?brunnen=2-0&napf=2
    const params = new URLSearchParams(window.location.search);
    const fountainParam = (params.get('brunnen') || '').toLowerCase().trim();
    const napfParam = (params.get('napf') || '').trim();

    function fountainKey(product) {
      const label = String((product && product.modelLabel) || '').toLowerCase();
      if (label.indexOf('edelstahl') !== -1 || label.indexOf('pro') !== -1) return 'edelstahl-pro';
      if (label.indexOf('2.0') !== -1 || label.indexOf('2,0') !== -1) return '2-0';
      return 'classic';
    }

    if (fountainParam && ['classic', 'edelstahl-pro', '2-0'].includes(fountainParam)) {
      const linkedProduct = products.find((item) => fountainKey(item) === fountainParam);
      if (linkedProduct) selectedProductId = String(linkedProduct.id);
    }

    if (napfParam === '1' || napfParam === '2') {
      const linkedProduct = products.find((item) => String(item.id) === String(selectedProductId)) || products[0];
      const linkedVariant = linkedProduct && linkedProduct.variants
        ? linkedProduct.variants.find((variant) => {
            const key = String(variant.key || variant.title || '');
            const isTwo = key.trim().charAt(0) === '2';
            return napfParam === '2' ? isTwo : !isTwo;
          })
        : null;
      if (linkedVariant) selectedVariantKey = linkedVariant.key;
    }

    function getProduct() {
      return products.find((item) => String(item.id) === String(selectedProductId)) || products[0];
    }

    function getVariant(product) {
      if (!product || !product.variants || !product.variants.length) return null;
      if (selectedVariantKey) {
        const matched = product.variants.find((variant) => variant.key === selectedVariantKey);
        if (matched) return matched;
      }
      return product.variants.find((variant) => variant.available) || product.variants[0];
    }

    function publishState(product, variant) {
      root.dataset.selectedProductId = String(product.id);
      root.dataset.selectedModelLabel = product.modelLabel || '';
      root.dataset.selectedIncludedLabel = product.includedLabel || product.modelLabel || '';
      root.dataset.selectedVariantKey = variant.key || variant.title || '';

      document.dispatchEvent(new CustomEvent('catzy:bundle-change', {
        detail: {
          group: data.group || root.dataset.bundleGroup || '',
          productId: String(product.id),
          modelLabel: product.modelLabel || '',
          includedLabel: product.includedLabel || product.modelLabel || '',
          variantKey: variant.key || variant.title || '',
          variantTitle: variant.title || '',
          price: variant.price || 0,
          compareAtPrice: variant.compareAtPrice || 0,
          available: !!variant.available
        }
      }));
    }

    function update() {
      const product = getProduct();
      const variant = getVariant(product);
      if (!product || !variant) return;

      selectedProductId = String(product.id);
      selectedVariantKey = variant.key;

      modelButtons.forEach((button) => {
        const active = String(button.dataset.productId) === selectedProductId;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      variantButtons.forEach((button) => {
        const active = button.dataset.bundleVariantKey === selectedVariantKey;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (masterSelect) {
        const targetOption = Array.from(masterSelect.options).find((option) => String(option.value) === String(variant.id));
        if (targetOption) masterSelect.value = String(variant.id);
      }

      if (priceEl) priceEl.innerHTML = money(variant.price);

      const hasCompare = variant.compareAtPrice && variant.compareAtPrice > variant.price;
      if (compareEl) {
        compareEl.innerHTML = hasCompare ? money(variant.compareAtPrice) : '';
        compareEl.classList.toggle('is-hidden', !hasCompare);
      }

      if (savingEl) {
        const saving = hasCompare ? variant.compareAtPrice - variant.price : 0;
        savingEl.innerHTML = saving > 0 ? 'Du sparst <strong>' + money(saving) + '</strong> im Set' : '';
        savingEl.classList.toggle('is-hidden', saving <= 0);
      }

      if (fountainName) fountainName.textContent = product.includedLabel || product.modelLabel || '';
      if (feederVariant) feederVariant.textContent = variant.key || variant.title || '';

      if (availability) availability.classList.toggle('is-sold-out', !variant.available);
      if (availabilityText) availabilityText.textContent = variant.available ? 'Auf Lager' : 'Ausverkauft';
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.classList.toggle('disabled', !variant.available);
      }
      if (addButtonText) {
        addButtonText.textContent = variant.available ? (addButtonText.dataset.defaultText || 'In den Warenkorb') : 'Ausverkauft';
      }

      publishState(product, variant);
    }

    modelButtons.forEach((button) => {
      button.addEventListener('click', function () {
        selectedProductId = String(button.dataset.productId);
        update();
      });
    });

    variantButtons.forEach((button) => {
      button.addEventListener('click', function () {
        selectedVariantKey = button.dataset.bundleVariantKey;
        update();
      });
    });

    update();
  }

  function initAll() {
    document.querySelectorAll('[data-catzy-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
